const Icon = ({ icon, className, onClick, disabled }: IconInterface) => {
  return (
    <>
      <i
        onClick={onClick}
        className={`${icon} ${className} flex justify-center  items-center cursor-pointer  ${
          disabled ? 'pointer-events-none cursor-default opacity-50' : ''
        }`}
      ></i>
    </>
  )
}

export default Icon
